export default __webpack_public_path__ + "static/card2-d08fdd3fc01b8624699b176f41e4d3c2.png";